import React from 'react';

interface SubItemProps {
  title: string;
  subtext?: string;
}

const SubItem: React.FC<SubItemProps> = ({ title, subtext="" }) => {
  return (
    <div className="py-4">
      <h3 className="text-base font-semibold">{title}</h3>
      <p className="text-sm text-muted-foreground">{subtext}</p>
    </div>
  )
};

export default SubItem;